const SVG_TEXT_PRESENTATION_ATTRS = [
  'font-size',
  'font-weight',
  'font-family',
  'fill',
  'opacity',
  'x',
  'y',
  'dx',
  'dy',
  'text-anchor',
  'dominant-baseline',
] as const;

/**
 * Copy SVG `<text>` presentation attributes from the live page onto the clone.
 * html-to-image often drops stylesheet rules on SVG, so the donut center
 * label would otherwise render at the default font size.
 */
export const copySvgTextPresentationAttributes = (
  source: HTMLElement,
  cloned: HTMLElement,
): void => {
  const sourceTexts = source.querySelectorAll('text');
  const clonedTexts = cloned.querySelectorAll('text');
  sourceTexts.forEach((src, index) => {
    const dst = clonedTexts[index];
    if (!dst) return;
    for (const attr of SVG_TEXT_PRESENTATION_ATTRS) {
      const value = src.getAttribute(attr);
      if (value === null) continue;
      dst.setAttribute(attr, value);
    }
  });
};
